import React from 'react';
import PropTypes from 'prop-types';

function StepIndicator({ currentStep, steps }) {
    const progress = currentStep >= steps.length ? 100 : (currentStep) * (100 / (steps.length - 1));
    const widthStyle = { width: `${progress}%` };
    return (
        <div className="step-indicator relative" aria-label="step-indicator">
            <div className="progress-bar absolute">
                <div className="progress-bar-mask" style={ widthStyle }></div>
            </div>
            <div className="flex align-items-center justify-content-space-between">
                {steps.map((step, index) => (
                    <div key={step} className="relative" role="listitem step" aria-current={currentStep === index && 'step'}>
                        <div className={`step-indicator__circle margin-center text-align-center relative border-radius-50 ${currentStep >= index ? 'current' : ''}`} />
                        <div className={`step-indicator__label absolute text-align-center margin-t-16px font-size-16px font-gray-45 font-w-4 ${currentStep >= index ? 'font-blue-30' : ''}`}>
                            <span className="step-indicator__inner-label relative">{step}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

StepIndicator.propTypes = {
    steps: PropTypes.array.isRequired,
    currentStep: PropTypes.number.isRequired,
};

export default StepIndicator;
